import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { MatIconModule } from '@angular/material/icon'

import { Interaction } from '../interaction-interface'
import { TopicButtons } from '../../topics/topic-buttons/topic-buttons'

@Component({
	selector: 'app-interaction-card-content',
	imports: [DatePipe, MatIconModule, TopicButtons],
	templateUrl: './interaction-card-content.html',
	styleUrl: './interaction-card-content.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractionCardContent {
	readonly interaction = input.required<Interaction>()
}
